require('./helpers/bundle-manifest').register(JSON.parse("{\"EVgbq\":\"index.js\",\"eJtOl\":\"tumbeast.de855889.png\",\"4W9cy\":\"index.css\"}"));